import React, { FC } from "react";
import { times } from "lodash";
import { TableBody, TableCell, TableRow } from "@mui/material";
import { IChannel, ISelection } from "../helper";
import { IVideo } from "../../../admin/videos/hooks/useFetchVideos";
import { useUser } from "../../../../hooks/useUser";
import { EditableCellValues } from "./EditableCellValues";
import { FixedCellValues } from "./FixedCellValues";
import { CheckboxIcon } from "./Checkbox";

interface Props {
  video: IVideo;
  group: any;
  channel: IChannel;
  selections: Array<ISelection>;
  setSelections: (data: Array<any>) => void;
}

export const MediaChannelTable: FC<Props> = (props) => {
  const { role } = useUser();
  const { selections, video, setSelections, channel } = props;

  const isSubChannelChecked = (subChannelId: Number, fileId: Number) =>
    !!selections.find(
      (e) =>
        e.sub_channel_id === subChannelId &&
        e.s3_file_id === fileId &&
        e.deactivated === false
    );

  return (
    <TableBody>
      {Array.isArray(channel?.subChannels) &&
        channel?.subChannels.map((subChannel) => {
          const selectionIndex = selections.findIndex(
            (e) =>
              e.sub_channel_id === subChannel.id && e.s3_file_id === video.id
          );
          const isChecked = isSubChannelChecked(subChannel.id, video.id);
          return (
            <TableRow
              key={subChannel.name}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <CheckboxIcon
                {...props}
                subChannel={subChannel}
                isChecked={isChecked}
              />

              {isChecked ? (
                // eslint-disable-next-line react/jsx-no-useless-fragment
                <>
                  {role === "ACCOUNT_MANAGER_ADMIN" || role === "ADMIN" ? (
                    <EditableCellValues
                      selection={selections[selectionIndex]}
                      onChange={(key: string, value: string | number) => {
                        const newSelections = [...selections];
                        if (newSelections[selectionIndex]) {
                          // @ts-ignore
                          newSelections[selectionIndex][key] = value;
                          newSelections[selectionIndex].isDirty = true;
                          setSelections(newSelections);
                        }
                      }}
                    />
                  ) : (
                    <FixedCellValues selection={selections[selectionIndex]} />
                  )}
                </>
              ) : (
                times(6, (i) => (
                  <TableCell
                    key={`empty-cell-${i}-for-${subChannel.name}`}
                    component={i === 0 ? "th" : "td"}
                    scope="row"
                  />
                ))
              )}
            </TableRow>
          );
        })}
    </TableBody>
  );
};
